import React, { useEffect, useState } from "react";
import { Tab, Tabs, NavLink, LinearProgress, Heading } from "../../components";
import { makeStyles } from "@material-ui/styles";
import sharedStyles from "../styles";
import { useTabsList } from "../../contexts/TabsContext";
import { useLocation, useHistory } from "react-router-dom";
import { Alert } from "@material-ui/lab";

const useStyles = makeStyles(sharedStyles);

export default function Header({ loading, permissions }) {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [accessDenied, setAccessDenied] = useState(false);

  // Define the tab paths and check if they're enabled
  const tabConfig = [
    {
      path: "/workflowDefs",
      label: "Workflows",
      isEnabled:
        permissions?.workflows?.active === "True" &&
        permissions?.workflows?.hide === "False",
    },
    {
      path: "/taskDefs",
      label: "Tasks",
      isEnabled:
        permissions?.tasks?.active === "True" &&
        permissions?.tasks?.hide === "False",
    },
    {
      path: "/eventHandlerDef",
      label: "Event Handlers",
      isEnabled:
        permissions?.event_handlers?.active === "True" &&
        permissions?.event_handlers?.hide === "False",
    },
  ];

  // Filter only enabled tabs
  const enabledTabs = tabConfig.filter((tab) => tab.isEnabled);

  // Handle navigation and permissions
  useEffect(() => {
    const currentPath = location.pathname;

    // If no tabs are enabled at all, redirect to no-access page
    if (enabledTabs.length === 0 && !currentPath.includes("/no-access")) {
      history.replace("/no-access");
      return;
    }

    // Find if current path matches any tab
    const matchingTabIndex = tabConfig.findIndex((tab) =>
      currentPath.includes(tab.path)
    );

    // If we found a matching tab
    if (matchingTabIndex >= 0) {
      const matchingTab = tabConfig[matchingTabIndex];

      // Check if user has permission for this tab
      if (!matchingTab.isEnabled) {
        setAccessDenied(true);
        // If user doesn't have permission but tries to access this path,
        // redirect to the first enabled tab (if any exist)
        if (enabledTabs.length > 0) {
          history.replace(enabledTabs[0].path);
        } else {
          // If no tabs are enabled, redirect to no-access page
          history.replace("/no-access");
        }
        return;
      }

      // User has permission for this tab
      setAccessDenied(false);

      // Find the index in the filtered enabledTabs array
      const enabledTabIndex = enabledTabs.findIndex(
        (tab) => tab.path === matchingTab.path
      );
      setActiveTabIndex(enabledTabIndex);
    } else {
      // If current path doesn't match any tab, set to first enabled tab
      if (enabledTabs.length > 0) {
        history.replace(enabledTabs[0].path);
      } else {
        // If no tabs are enabled, redirect to no-access page
        history.replace("/no-access");
      }
    }
  }, [location.pathname, tabConfig, enabledTabs, history]);

  return (
    <>
      {accessDenied && (
        <Alert severity="warning" style={{ margin: "10px" }}>
          You don't have permission to access this page. Redirecting...
        </Alert>
      )}

      <Tabs
        value={activeTabIndex}
        className={classes.tabHeader}
        textColor="primary"
      >
        {enabledTabs.map((tab, index) => (
          <Tab
            key={tab.path}
            label={tab.label}
            component={NavLink}
            path={tab.path}
          />
        ))}
      </Tabs>
    </>
  );
}
